import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import useStyles from './styles';
import ApiService from '../../services/ApiService';

export default function AddWorkshopPopUp(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [addNewWorkshopName, setAddNewWorkshopName] = useState([]);
  const { open } = props;

  const handleClose = () => {
    props.setPopUpOpenedState();
  };

  const onTextFieldValueChange = (e) => {
    setAddNewWorkshopName(e.target.value);
  };

  const handleValidateButtonClick = () => {
    ApiService.addNewActualWorkshops(addNewWorkshopName)
      .then((response) => {
        console.log(response.data);
        props.setPopUpOpenedState();
      })
      .catch((error) => {
        console.log('Unable to add new workshop in the list', error);
        props.setPopUpOpenedState();
      });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent className={classes.dialog}>
        <DialogContentText className={classes.dialogTextTitle}>
          {t('add_actual_workshop')}
        </DialogContentText>
        <DialogContentText className={classes.dialogText}>
          {t('enter_the_workshop_name')}
        </DialogContentText>
        <DialogContentText className={classes.dialogText}>
          {t('workshop_name')}
        </DialogContentText>
        <TextField
          className={classes.textfield}
          variant="outlined"
          placeholder="Enter Workshop Name"
          type="text"
          onChange={(e) => {
            onTextFieldValueChange(e);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleValidateButtonClick}
        >
          {t('Validate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
